<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="thkMaterial.pkid > 0 ? '编辑':'新建'"
        width="1000px"
        top="5vh"
        @close="$reset('form')">
      <el-form ref="form" :model="thkMaterial" :rules="ruleValidate" label-width="100px">
        <el-tabs value="tab1" type="border-card">
          <el-tab-pane name="tab1" label="基础信息">
            <el-row>
              <el-col :span="12">
                <el-form-item label="物料号" prop="materialNo">
                  <el-input v-model.trim="thkMaterial.materialNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="规格描述" prop="materialName">
                  <el-input v-model="thkMaterial.materialName"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="变频器型号" prop="param1">
                  <el-input v-model="thkMaterial.param1"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机房形式" prop="param2">
                  <el-input v-model="thkMaterial.param2"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="Q00 In(A)" prop="param3">
                  <el-input v-model="thkMaterial.param3"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="曳引机" prop="param4">
                  <el-input v-model="thkMaterial.param4"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="集成式ARP" prop="param5">
                  <el-input v-model="thkMaterial.param5"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="K00 In(A)" prop="param6">
                  <el-input v-model="thkMaterial.param6"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="标准" prop="param7">
                  <el-input v-model="thkMaterial.param7"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注" prop="note">
                  <el-input type="textarea" v-model="thkMaterial.note"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane name="tab2" label="附件">
            <div>
              <el-upload
                  action=""
                  multiple
                  :http-request="submitUpload"
                  :show-file-list="false"
                  :disabled="uploadLoading"
                  style="display: inline-block; float: left; margin: 5px;">
                <el-button type="primary" plain>
                  <i class="el-icon-upload el-icon--right"/>
                  附件上传
                </el-button>
              </el-upload>
            </div>
            <el-table :data="thkMaterial.accessory" height="50vh">
              <el-table-column type="index" align="center" label="行号"/>
              <el-table-column prop="fileName" align="center" label="附件">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.fileName}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="fileDownload(scope.row,scope.$index)">下载</el-button>
                  <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ThkMaterialBoxEdit",
    // components: {ProductControlBoxSelect},
    data() {
      return {
        dialogVisible: false,
        dataTypes: constant.toSelect(constant.dataType),
        valueTypes: constant.toSelect(constant.valueType),
        contentLoading: false,
        submitLoading: false,
        uploadLoading:false,
        thkMaterial: {
          pkid: 0,
          materialType: 151,
          materialNo: "",
          materialName: "",
          param1: "",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
          param6: "",
          param7: "",
          note: "",
          accessory: "",
        },
        ruleValidate: {
          materialNo: [{required: true, message: "不能为空", trigger: "blur"}],
          materialName: [{required: true, message: "不能为空", trigger: "blur"}],
        },
      };
    },
    methods: {
      open: function(id, isCopy) {
        if (isCopy === 1) {
          this.isCopy = 1;
        }
        this.thkMaterial.pkid = id;
        if (id) {
          this.getData(id);
        }
        this.dialogVisible = true;
      },
      getData(id) {
        this.$http
            .get("basic", `thkMaterials/${id}`)
            .then(resp => {
              console.log(resp);
              if (resp.success) {
                this.thkMaterial = resp.data;
              }
            });
      },
      handleSubmit() {
        let isAdd = 1;
        if (this.thkMaterial.pkid) {
          isAdd = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", `thkMaterials/save/${isAdd}`, this.thkMaterial)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(resp.message);
                    this.submitLoading = false;
                  }

                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "file/batch/0", formData)
            .then((res) => {
              this.uploadLoading = false;
              const fileInfo = res.data.attachments[0];
              console.log(fileInfo);
              this.thkMaterial.accessory.push({
                fileName: fileInfo.fileName,
                filePath: "/attached/file/" + fileInfo.filePath,
                note: "",
              });
              this.$message.success("上传成功");
            })
            .catch(() => {
              this.uploadLoading = false;
              this.$message.error("上传失败");
            });
      },
      fileDelete(row, index) {
        this.thkMaterial.accessory.splice(index, 1);
      },
      fileDownload(row, index) {
        window.open(window.config.fileServerUrl + row.filePath);
      },

    },
  };
</script>

<style lang="scss" scoped>
</style>
